import React from "react"
import { array, object, string } from "yup"

import CategorySelect from "../../PublishForm/CategorySelect"
import PublishForm from "../../PublishForm/PublishForm"
import { Area, Field } from "../../PublishForm/PublishInput"
import UploadContent from "../../PublishForm/UploadContent"

const initialValues = {
  title: "",
  summary: "",
  seriesId: "",
  categories: [],
  attachments: []
}

const validation = object().shape({
  title: string().required("A title for your research is required"),
  summary: string().required("A short summary of your research is required"),
  seriesId: string(),
  categories: array().of(string()),
  attachments: array().min(2, "A PDF and cover image are required")
})

const CreateForm = ({ onSubmit, isLoading, hasCreated, renderSeriesCreator: CreateSeries }) => (
  <PublishForm
    postType="research"
    initialValues={initialValues}
    validation={validation}
    onSubmit={onSubmit}
    isLoading={isLoading}
    hasCreated={hasCreated}
    render={({
      handleChange,
      handleBlur,
      handleSelect,
      handleCloseDropdown,
      setValues,
      setTouched,
      values,
      touched,
      errors
    }) => {
      const handleAttachment = attachments => {
        setValues({ ...values, attachments })

        if (attachments.length > 0) {
          setTouched({ ...touched, attachments: true })
        }
      }

      return (
        <>
          <Field
            onSelect={handleSelect}
            id="research-title"
            name="title"
            type="text"
            label="Title"
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.title}
            error={touched.title && errors.title}
          />
          <CreateSeries name="seriesId" onChange={handleChange} />
          <CategorySelect
            label="Categories"
            name="categories"
            helperText="Select categories for your research (max 3)"
            onChange={handleChange}
            closeDropdownTrigger={handleCloseDropdown}
          />
          <Area
            onSelect={handleSelect}
            height={[248, 124]}
            id="research-summary"
            name="summary"
            type="text"
            label="Summary"
            onChange={handleChange}
            onBlur={handleBlur}
            maxLength={250}
            helperText="Summary and key points covered in your research"
            value={values.summary}
            error={touched.summary && errors.summary}
          />
          <UploadContent
            type="document"
            helperTexts={[
              "Attach PDF of your research and a cover image (image must be square).",
              "Please compress your files to below 80MB each before uploading."
            ]}
            onSelect={handleAttachment}
            error={touched.attachments && errors.attachments}
          />
        </>
      )
    }}
  />
)

export default CreateForm
